import {FullscreenPanel, FullscreenPanelBody} from '@logistics-frontend/blocks'
import {memo, useCallback, useMemo, useState} from 'react'

import {useAddresses} from '../../lib/useAddresses'
import {Map} from '../Map/Map'
import {RouteInfo} from '../RouteInfo/RouteInfo'

/** Пропсы компонента RouteMap */
type RouteMapProps = {
  /** Действие при закрытии модалки */
  onClose: VoidFunction
}

/**
 * Фулскрин-модалка с маршрутом: карта с маршрутом и управление адресами маршрута в дровере.
 * При любом изменении данных маршрут меняется и в стейте.
 */
export const RouteMap = memo<RouteMapProps>(function RouteMap({onClose}) {
  const route = useAddresses()

  const [mapBottomOffset, setMapBottomOffset] = useState<number>(0)

  const routeCoordinates = useMemo(() => route.map(({coordinates}) => coordinates), [route])

  const measureRouteInfoHeight = useCallback((node: HTMLElement) => {
    if (node) {
      setMapBottomOffset(node.offsetHeight)
    }
  }, [])

  return (
    <FullscreenPanel anchor="bottom" opened>
      <FullscreenPanelBody>
        <Map bottomOffset={mapBottomOffset} onGoBack={onClose} route={routeCoordinates} />
        <RouteInfo ref={measureRouteInfoHeight} onClose={onClose} route={route} />
      </FullscreenPanelBody>
    </FullscreenPanel>
  )
})
